// import SignInPage from '@/views/signIn/SignIn.vue';
const SignInPage = () => import('@/views/signIn/SignIn.vue');

import getWhiteLabel from '@/utils/getWhiteLabel';

const signinRouter = {
    path: '/',
    component: SignInPage,
    name: 'signin',
    meta: {
        title: `${getWhiteLabel()} - Login`,
        requiresAuth: false
    },

}

export default signinRouter;